(() => {
  if (window.cazaHeroVideoInitialized) return;
  window.cazaHeroVideoInitialized = true;

  const mobile = window.matchMedia('(max-width: 768px)');
  const initialized = new WeakMap();

  function initialize() {
    document.querySelectorAll('.hero-caza video').forEach((video) => {
      if (initialized.has(video)) return;

      function playOnMobile() {
        if (!mobile.matches || !video.isConnected || !video.getClientRects().length) return;
        video.defaultMuted = true;
        video.muted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.removeAttribute('controls');
        if (video.paused) {
          const playback = video.play();
          if (playback) playback.catch(() => {});
        }
      }

      initialized.set(video, playOnMobile);
      video.addEventListener('loadedmetadata', playOnMobile);
      video.addEventListener('canplay', playOnMobile);
      playOnMobile();
    });
  }

  function resume() {
    document.querySelectorAll('.hero-caza video').forEach((video) => {
      initialized.get(video)?.();
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', resume);
  mobile.addEventListener('change', resume);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) resume();
  });
})();
